import { IHousingObjectResponse } from '@/types';
import { StructuredData } from '@/types/structuredData';
import { generateListingDetailSchema } from './generateListingDetailSchema';

const BASE_URL = process.env.BASE_URL ?? 'https://alleimmobilien.at';

export const generateDiscountedListingsSchema = (
  objects: IHousingObjectResponse[],
  locale: string,
): StructuredData[] =>
  objects.map((obj) => {
    const slugId = obj.slug ? `${obj.slug}__${obj.id}` : String(obj.id);
    const url = `${BASE_URL}/${locale}/housing/${slugId}`;
    return generateListingDetailSchema(obj, url);
  });
